import { useContext, useEffect, useState } from "react";
import { CheckBox } from "shared/Components/checkbox";
import moment from "moment";
import { globalVariables } from "helper/globalVariables";
// import { useMutation } from "@apollo/client";
import { DogRegistrationStatusUpdate } from "redux/features/dogSlice/dogGql";
import { client } from "helper/apolloConfig";
import { useLocation } from "react-router-dom";
import { RoleContext } from "context/RoleContext";
import { dog } from "helper/images";
import Dropdown from "shared/Components/dropdown";

const AdminDogInfo = ({
  tabChanged,
  isAdmin = false,
  dogInfo,
  setDashboardData,
}) => {
  const { state } = useLocation();
  const role = useContext(RoleContext);
  console.log(role);
  // const [updateDogStatus] = useMutation(DogRegistrationStatusUpdate);
  const [retiredChecked, setRetiredChecked] = useState(false);
  const [deceasedChecked, setDeceasedChecked] = useState(false);
  const {
    dogImage,
    status,
    call_name,
    registration_name,
    breed,
    breed_mix,
    gender,
    date_of_birth,
    payment_status,
    id,
  } = dogInfo?.dog || {};

  useEffect(() => {
    if (status === globalVariables.retired) {
      setRetiredChecked(true);
    } else if (status === globalVariables.deceased) {
      setDeceasedChecked(true);
    }
  }, [status]);

  useEffect(() => {
    setRetiredChecked(false);
    setDeceasedChecked(false);
  }, [tabChanged]);

  const paymentStatus =  payment_status == "Unpaid" ? globalVariables.pending : globalVariables.active;

  const onUpdateStatus = async (status) => {
    const res = await client.mutate({
      mutation: DogRegistrationStatusUpdate,
      variables: {
        id,
        status,
      },
    });
    if (res.data) {
      const dog = { ...dogInfo.dog, status };
      setDashboardData({ ...dogInfo, dog });
    }
  };
  
  const handleRetiredChange = () => {
    const newRetiredChecked = !retiredChecked; 
    setRetiredChecked(newRetiredChecked);
    setDeceasedChecked(false);
  
    if (!newRetiredChecked && !deceasedChecked) {
      onUpdateStatus(paymentStatus); 
    } else {
      onUpdateStatus(newRetiredChecked ? globalVariables.retired : paymentStatus);
    }
  };
  
  const handleDeceasedChange = () => {
    const newDeceasedChecked = !deceasedChecked;
    setDeceasedChecked(newDeceasedChecked);
    setRetiredChecked(false);
  
    if (!newDeceasedChecked && !retiredChecked) {
      onUpdateStatus(paymentStatus);
    } else {
      onUpdateStatus(newDeceasedChecked ? globalVariables.deceased : paymentStatus);
    }
  };

  return (
    <div className="rounded-md shadow-100 bg-white flex flex-col items-start gap-6 self-stretch relative p-4">
      <div className="flex flex-col sm:flex-row">
        {/* Use flex container for alignment */}
      <div className="flex items-center justify-center lg:w-[200px] md:w-[222px] w-[200px] h-[200px] flex-shrink-0 relative mb-4 sm:mb-0 sm:mr-4">
        <img
          src={dogImage || dog}
          alt="dogImage"
          className="w-full h-full object-cover rounded-full border"
        />
        <div className="absolute top-[10px] left-[10px] text-[11px] font-medium text-[#067647] bg-[#ECFDF3] rounded-full border border-green-500 shadow-lg inline-flex px-1 items-center">
          {status}
        </div>
      </div>
        {/* border-b-2 border-gray-200  */}
        <div className="w-auto lg:w-[650px]">
          {/* <div className="flex flex-col gap-4 md:flex-row md:gap-12 border-b-2 border-gray-200 ">
            <div>
              <div className="text-gray-700 font-inter font-medium text-base leading-7">
                Dog Name
              </div>
              <div className="text-gray-900 font-semibold font-inter text-lg leading-5 pb-[21px]">
                {call_name}
              </div>
            </div>
            {role !== "Member" && (
              <div>
                <div className="text-gray-700 font-inter font-medium text-base leading-7">
                  Owner Name
                </div>
                <div className="text-gray-900 font-semibold font-inter text-lg leading-5 pb-[21px]">
                  {state?.ownerName}
                </div>
              </div>
            )}
          </div> */}

          <div className="flex flex-col md:flex-row md:gap-20 mr-6 justify-between	border-b-2 border-gray-200">
            {/* <div className='flex flex-col mb-6 sm:mb-0 sm:mr-12'> */}
            <div className="text-gray-500 font-inter text-sm leading-5 mt-4">
              Dog Name
              <div className="text-gray-900 font-inter font-bold text-2xl leading-7 mt-1">
                {call_name}
              </div>
            </div>
            {role !== "Member" && (
              <div className="text-gray-500 font-inter text-sm leading-5 mt-4 w-[200px]">
                Owner Name
                <div className="text-gray-900 font-inter font-semibold text-base leading-7">
                  {state?.ownerName}
                </div>
              </div>
            )}
          </div>
          <div className="flex flex-col md:flex-row md:gap-20 mr-6 justify-between	">
            {/* <div className='flex flex-col mb-6 sm:mb-0 sm:mr-12'> */}
            <div className="text-gray-500 font-inter text-sm leading-5 mt-4">
              Registered Name
              <div className="text-gray-900 font-inter font-semibold text-base leading-7">
                {registration_name ? registration_name : "Not Available"}
              </div>
            </div>
            <div className="text-gray-500 font-inter text-sm leading-5 mt-4 w-[200px]">
              Breed
              <div className="text-gray-900 font-inter font-semibold text-base leading-7">
                {breed_mix || breed}
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row mr-6 justify-between">
            {/* <div className='flex flex-col mb-6 sm:mb-0 sm:mr-12'> */}
            <div className="text-gray-500 font-inter text-sm leading-5 mt-4">
              Gender
              <div className="text-gray-900 font-inter font-semibold text-base leading-7">
                {gender ? gender : "Not Available"}
              </div>
            </div>
            <div className="text-gray-500 font-inter text-sm leading-5 mt-4 w-[200px]">
              Birthday
              <div className="text-gray-900 font-inter font-semibold text-base leading-7">
                {date_of_birth
                  ? moment(date_of_birth).format("MM/DD/YYYY")
                  : "Not Available"}
              </div>
            </div>
          </div>

          {/* <div className='flex flex-col sm:flex-row  mr-6'>

                        <div className="text-gray-500 font-inter text-sm leading-5 mt-4">
                            Status
                            <div className="text-gray-900 font-inter font-semibold text-base leading-7 flex mt-2">
                                <label className="flex items-center">
                                    <input type="radio" name="status" />
                                    <span className="ml-2 text-gray-500 font-inter text-sm">Active</span>
                                </label>
                                <label className="flex items-center ml-4">
                                    <input type="radio" name="status" />
                                    <span className="ml-2 text-gray-500 font-inter text-sm">Inactive</span>
                                </label>
                            </div>

                        </div>
                    </div> */}
        </div>
      </div>

      {isAdmin ? (
        <div className="absolute top-[35px] right-[70px] items-end flex flex-row hidden sm:flex">
          <CheckBox
            label="Retired"
            isChecked={retiredChecked}
            onChange={handleRetiredChange}
          />
          <div className="m-2" />
          <CheckBox
            label="Deceased"
            isChecked={deceasedChecked}
            onChange={handleDeceasedChange}
          />
        </div>
      ) : (
        <div className="absolute top-[30px] right-[45px] items-end flex flex-row hidden sm:flex">
          <Dropdown
            defaultOption={status}
            width={"w-[150px]"}
            mainContent="w-100%"
            dropdownOptions={["Pending", "Active"]}
            onChange={(option) => {
              if (option !== status) onUpdateStatus(option);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default AdminDogInfo;
